import { AxiosResponse } from "axios";
import { axiosAuthenticated } from "../../../service/http";
import { ReportingParameters } from "../models/reporting-parameters";
import { TotalsSuccessResponse } from "../models/reporting-success-response";

export const XLSXMimeType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const reportingHttp = {
  getReportingData: async (data: ReportingParameters, apiUrlKey?: string) => {
    const { organizationKeyName, ...body } = data;
    const params = new URLSearchParams();
    if (body) {
      Object.entries(body).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
      });
    }
    const url = `/organizations/${organizationKeyName}/reporting/${apiUrlKey}?${params.toString()}`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<TotalsSuccessResponse>
    >(url);
    const responseData = response.data;
    return responseData;
  },

  getReportingBlob: async (data: ReportingParameters, apiUrlKey: string) => {
    const { organizationKeyName, ...body } = data;
    const params = new URLSearchParams();
    if (body) {
      Object.entries(body).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
      });
    }
    const url = `/organizations/${organizationKeyName}/reporting/${apiUrlKey}?${params.toString()}`;
    return await axiosAuthenticated.get<any, AxiosResponse>(url, {
      responseType: "blob",
    });
  },
};
